import React, { useEffect, useState } from "react";
import { selectSignedIn } from "reducers/auth";
import { useDispatch, useSelector } from "react-redux";
import instance from "api";
import { endpoints } from "config";
import Logo from "assets/principle_connect_logo.jpg";
import { setBrandLogo } from "reducers/brandSettings";

const BrandSettings = () => {
  const [loadedBrandLogo, setLoadedBrandLogo] = useState<boolean>(false);

  const signedIn = useSelector(selectSignedIn);
  const dispatch = useDispatch();

  const getBrandLogo = async () => {
    const result = await instance.get(endpoints.profile.getBrandSettings);

    if (
      result?.data?.status === "1" &&
      result?.data?.details?.imageURL &&
      typeof result.data.details.imageURL === "string"
    ) {
      dispatch(setBrandLogo(result.data.details.imageURL));
    }

    setLoadedBrandLogo(true);
  };

  useEffect(() => {
    if (signedIn) {
      if (!loadedBrandLogo) {
        getBrandLogo();
      }
    } else {
      setLoadedBrandLogo(false); // NOTE: So when the user signs back in we recall the endpoint to hopefully get the new logo
    }
  }, [signedIn]);
  return <></>;
};

export default BrandSettings;
